import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";

export const deleteBrand = unaryRpc({
  name: "deleteBrand" as const,
  input: z.object({ id: z.string() }),
  output: z.object({ success: z.boolean() }),
});
